/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useState } from "react";
import { Logger } from "cms/utils/log/logger";
import { isStringEmpty } from "utils/empty-exists";
import { useUpdateComponent } from "cms/components/hooks/use-update-component";
import { DEFAULTS } from "cms/images/image-inpage-editor-v2/image-helpers";
import { ImageInPageEditorV2 } from "cms/images/image-inpage-editor-v2/index";

const ImageComponentEditor = () => {
    
    const { component, update } = useUpdateComponent();

    const _image = component?.image;
    const _settings = component?.settings ?? DEFAULTS.DEFAULT_IMAGE_SETTINGS;
    
    const [image,setImage] = useState(_image);
    const [settings,setSettings] = useState(_settings);
    
    const onChangeImageWithSettings = (image, settings) => {
        const { guid } = image || {};
        if (isStringEmpty(guid)) {
            Logger.warn("[onChangeImageWithSettings] image guid missing", { image, guid });
        } else {
            setImage(image);
            setSettings(settings);
            update("settings", settings);
            update("image", guid);
            // Logger.info(red(`[onChangeImageWithSettings]`), {image, settings})
        }
    };
    
    const onRemoveImage = () => {
        // updateImage('')
        setImage(undefined);
        setSettings(undefined);
        update("settings", {});
        update("image", "");
    };
    
    return (
        <div className='simplicity-editor-frame'>
            <ImageInPageEditorV2
                image_guid={image}
                settings={settings}
                onChangeImageWithSettings={onChangeImageWithSettings}
                onRemoveImage={onRemoveImage}
            />
        </div>
    );
};
ImageComponentEditor.displayName = "ImageComponentEditor";
export { ImageComponentEditor };
